import React, { useState, useEffect, useContext,useCallback } from 'react';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Layout from 'components/sales/layout/layout';
import CarnivalForm from './carnivalForm';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { useParams } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import { handleValidateObj } from 'constants/objValues/objvalues';
import 'react-toastify/dist/ReactToastify.css';
import {
  getHelpdeskDataForUpdation,
  saveHelpdesk,
  updateHelpdeskData
} from "../../../../services/redux/brandActivtion/conductCamp/action";

const AddHelpdesk = ({
  match,
  history,
  documentUrlDataPublic,
  documentUploadUrlPublic,
  getLeadInfraId,
  leadInfraId,
  saveHelpdesk,
  getHelpdeskDataForUpdation,
  helpdeskData,
  updateHelpdeskData
}) => {
  const [isFiled, setIsFiled] = useState(false);
  // const [siteId, setSiteId] = useState(null);
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const inputs = {
    meetingDetails: null,
  };
  const [isModal, setIsModal] = useState(false);
  const [infraIdMissingModal, setIsInfraIdMissingModal] = useState(false);
  const [details, setDetails] = useState(null);
  const [meetingData, setCorporateData] = useState(inputs);
  const handleForm = (val) => {
    setCorporateData({ ...meetingData, meetingDetails: val });
  };

  //For Updating Carnival
  const getCarnivalData = useCallback(async () => {
    if (match?.params?.id) {
      setIsLoading(true);
      await getHelpdeskDataForUpdation(match?.params?.id);
      setIsLoading(false);
    }
  }, [getHelpdeskDataForUpdation, match?.params?.id]);

  useEffect(() => {
    getCarnivalData();
  }, [getCarnivalData]);


  //End Carnival Updation

  const handleSubmit = () => {
    const { meetingDetails } = meetingData;
    if (meetingDetails === null) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      if (meetingDetails?.isEdit == 1) {
        (async () => {
          const res = await updateHelpdeskData(meetingDetails);
          if (res) {
            setIsModal(true);
          }
        })();
      } else {
        (async () => {
          const res = await saveHelpdesk(meetingDetails);
          if (res) {
            setIsModal(true);
          }
        })();
      }
    }
  };

  const handleModalHide2 = () => {
    setIsInfraIdMissingModal(false);
    history.push(`${baseUrl}/brand-activation/helpdesk`);
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.scheduleHelpdesk}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  return (
    <Layout
      title={localization.scheduleHelpdesk}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/helpdesk`}
    >
      <CarnivalForm
        handleValue={handleForm}
        getLeadInfraId={getLeadInfraId}
        // siteId={siteId}
        leadInfraId={leadInfraId}
        documentUploadUrl={documentUploadUrlPublic}
        documentUrlData={documentUrlDataPublic}
        prefilledData={helpdeskData}
      />
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide2}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{meetingData?.meetingDetails?.isEdit == 1 ? localization.helpdeskUpdateSuccess : localization.helpdeskSuccess}</h5>
          <Button onClick={handleModalHide2} className="btn btn-primary mb-4">
            {localization.goToHelpdeskListing}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
    </Layout>
  );
};

AddHelpdesk.propTypes = {};

export default AddHelpdesk;
